// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const closePipCodeRequestModal = () =>

    dispatch => {

        document.body.classList.remove('warranty-modal-is-open');

        dispatch({
            type: actions.CLOSE_TCSM_PIP_CODE_REQUEST_MODAL
        });

    };

export const openPipCodeRequestModal = actionToTake =>

    dispatch => {

        document.body.classList.add('warranty-modal-is-open');

        dispatch({
            actionToTake,
            type: actions.OPEN_TCSM_PIP_CODE_REQUEST_MODAL
        });

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/pip-code-request-modal.js